import type { LocaleCode, NestedKeys } from "~/types";
import { getBranch } from "./branch";
import { en, ru, sv, he } from 'vuetify/locale';
import faqs from "../i18n/locales/partials/faqs";
import testimonials from '../i18n/locales/partials/testimonials';
import countries from "../i18n/locales/partials/countries";
import emailSubjects from "../i18n/locales/partials/email-subjects";
import blogCategories from "../i18n/locales/partials/blog-categories";
import errors from "../i18n/locales/partials/errors";
import enRest from '../i18n/locales/partials/rest/en';
import ruRest from '../i18n/locales/partials/rest/ru';
import svRest from '../i18n/locales/partials/rest/sv';
import heRest from '../i18n/locales/partials/rest/he';
import ruKzRest from '../i18n/locales/partials/rest/ru-KZ';
import { localeToLanguage } from "./format";

const RTL_LOCALES: LocaleCode[] = ['he'];

export type I18nMessages = ReturnType<typeof buildLocale>;
export type I18nKey = NestedKeys<I18nMessages>;

const vuetifyLocales = { en, ru, sv, he };
const rest = { en: enRest, ru: ruRest, sv: svRest, he: heRest, 'ru-KZ': ruKzRest };

export function buildLocale(locale: LocaleCode) {
  const language = localeToLanguage(locale);
  return {
    ...rest[locale],
    faqs: faqs[language],
    testimonials: testimonials[locale],
    countries: countries[language],
    errors: errors[language],
    email_subjects: emailSubjects[language],
    blog_categories: blogCategories[language],
    $vuetify: vuetifyLocales[language]
  };
}

export function getLocale() {
  return getBranch().locale;
}

export function isRtl(locale: LocaleCode) {
  return RTL_LOCALES.includes(locale);
}